<template>
  <v-layout row justify-center>
    <v-dialog v-model="show" persistent max-width="400">
      <v-card>
        <v-card-text>
          <v-container grid-list-xl fluid>
            <v-layout row wrap>
              <v-flex xs6>
                <v-menu
                  :close-on-content-click="false"
                  v-model="dateMenu"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <v-text-field
                    name="date"
                    slot="activator"
                    :value="date ? $moment(date).format('LL') : null"
                    :label="$t('date')"
                    v-validate="'required'"
                    :data-vv-as="$t('date')"
                    :error-messages="errors.collect('date')"
                    readonly
                  ></v-text-field>
                  <v-date-picker
                    v-model="date"
                    @input="dateMenu = false"
                    :locale="LANG"
                    reactive
                    :max="$moment().format('YYYY-MM-DD')"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  name="time"
                  v-model="time"
                  v-validate="'required'"
                  :data-vv-as="$t('time')"
                  :error-messages="errors.collect('time')"
                  type="time"
                  prepend-icon="access_time"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" flat @click="show = false">{{
            $t("cancel")
          }}</v-btn>
          <v-btn color="green darken-1" flat @click="clickConfirm">{{
            $t("ok")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div
      v-if="!show"
      @click="show = true"
      style="display: inline-block; width: 100%; text-align: center; line-height: 40px; height: 40px; cursor: pointer"
    >
      {{ value ? $moment(value).format("LLL") : "" }}
    </div>
    <v-btn small flat v-if="value" @click.native="clickRemove()" icon>
      <v-icon small>close</v-icon>
    </v-btn>
  </v-layout>
</template>

<script>
export default {
  data() {
    return {
      show: false,
      dateMenu: false,
      date: null,
      time: null,
      LANG: process.env.VUE_APP_LANG
    };
  },
  props: ["title", "value"],
  methods: {
    clickCancel() {
      this.$emit("cancel");
    },
    clickConfirm() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.show = false;
          this.$emit(
            "input",
            this.$moment(this.date + " " + this.time).format()
          );
        }
      });
    },
    clickRemove() {
      this.$emit("input", null);
    }
  }
};
</script>
